<template>
    <div>
        <v-tooltip top v-model="showTooltip">
            <template v-slot:activator="{ on, attrs }">
                <v-btn text icon large @click="handleClipBoard($props.text)" v-bind="attrs" v-on="on">
                    <v-icon color="primary">mdi-content-copy</v-icon>
                </v-btn>
            </template>
            <span>{{ hoverText }}</span>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    props: ['text'],
    data: () => ({
        copyToClipBoard: 'Copy To Clipboard',
        hoverText: 'Copy To Clipboard',
        errorCopying: "error copying text",
        showTooltip: false,
        timeoutId: null,
    }),
    methods: {
        async handleClipBoard(text) {
            try {
                await navigator.clipboard.writeText(text)
                this.hoverText = "copied"
                clearTimeout(this.timeoutId)
                this.showTooltip = true;

                this.timeoutId = setTimeout(() => {
                    this.hoverText = this.copyToClipBoard
                    this.showTooltip = false;

                }, 2000)
            } catch (e) {
                this.hoverText = this.errorCopying
                this.showTooltip = true;
                setTimeout(() => {
                    this.hoverText = this.copyToClipBoard
                    this.showTooltip = false;
                }, 2000)
                console.log(this.errorCopying)
            }
        }
    }

}


</script>